<via-loading-spinner *ngIf="loading"></via-loading-spinner>
<div class="e-configure-data-layout">
    <h3 class="e-filter-options-heading">Date Range, Price &amp; Total SKU Size</h3>

    <div class="e-configure-data-options e-date-range-options">
        <!-- <div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Frequency</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="frequencyTooltipText" *ngIf="dailyFrequencySelected"></via-info-icon>
                </div>
                <div>
                    <via-ui-frequency-dropdown [selectedFrequency]="'Weekly'"></via-ui-frequency-dropdown>
                </div>
            </div>
        </div> -->
        <div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Date range</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="dateRangeTooltipText"></via-info-icon>
                </div>
                <div>
                    <mat-form-field appearance="fill">
                        <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker" [min]="minDate" [max]="maxDate">
                            <input readonly matStartDate formControlName="startDate" placeholder="Start date" />
                            <input readonly matEndDate (dateChange)="checkCancelAndFilterButton()" formControlName="endDate" placeholder="End date" />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>

    <div class="e-configure-data-options">
        <div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">First seen price</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="firstSeenPriceTooltipText"></via-info-icon>
                </div>
                <div>
                    <input class="e-number-input" id="firstSeenPriceLower" type="text" [(ngModel)]="firstSeenPriceLower" (keyup)="validateFirstSeenPriceRange()" />
                </div>
                <span>-</span>
                <div>
                    <input class="e-number-input" id="firstSeenPriceUpper" type="text" [(ngModel)]="firstSeenPriceUpper" (keyup)="validateFirstSeenPriceRange()" />
                </div>
            </div>
        </div>
        <div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Last seen price</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="lastSeenPriceTooltipText"></via-info-icon>
                </div>
                <div>
                    <input class="e-number-input" id="lastSeenPriceLower" type="text" [(ngModel)]="lastSeenPriceLower" (keyup)="validateLastSeenPriceRange()" />
                </div>
                <span>-</span>
                <div>
                    <input class="e-number-input" id="lastSeenPriceUpper" type="text" [(ngModel)]="lastSeenPriceUpper" (keyup)="validateLastSeenPriceRange()" />
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="e-configure-data-options e-no-gap">
        <div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Price Point</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="pricePointTooltipText"></via-info-icon>
                </div>
                <div>
                    <mat-radio-group aria-label="Select an option">
                        <mat-radio-button
                            *ngFor="let pricePoint of pricePoints"
                            [value]="pricePoint"
                            [checked]="this.configureData.pricePoint === pricePoint">
                            Price per {{ pricePoint }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Currency</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="currencyTooltipText"></via-info-icon>
                </div>
                <div>
                    <via-ui-currency-dropdown [selectedCurrency]="this.configureData.currency"></via-ui-currency-dropdown>
                </div>
            </div>
        </div>
    </div> -->

    <div class="e-configure-data-options e-sku-size-options">
        <div>
            <div class="e-configure-data-row">
                <div>
                    <label class="e-input-label">Total SKU Size</label>
                </div>
                <div>
                    <via-info-icon [tooltipText]="totalSkuSizeTooltipText"></via-info-icon>
                </div>
                <div>
                    <div class="e-sku-size-option-row">
                        <div>
                            <mat-checkbox [(ngModel)]="volumeChecked" (click)="checkCancelAndFilterButton()">Volume</mat-checkbox>
                            <div>
                                <mat-form-field appearance="fill" class="e-mat-select-tiny">
                                    <mat-select
                                        panelClass="e-mat-select-panel-tiny"
                                        [disabled]="!volumeChecked"
                                        [(value)]="volumeSelected"
                                        (selectionChange)="onVolumeSelectionChange($event)"
                                        [formControl]="frmControlVolume">
                                        <mat-option *ngFor="let unit of volumeOptions" [value]="unit">
                                            {{ unit }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <button
                                    class="e-reset-button"
                                    aria-label="Reset volume selections to default values"
                                    [disabled]="!volumeChecked">
                                    <i class="fa-regular fa-arrow-rotate-left" (click)="onVolumeReset()"></i>
                                </button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <input
                                    id="fromVolume"
                                    class="e-number-input"
                                    type="text"
                                    [(ngModel)]="fromVolume"
                                    [disabled]="!volumeChecked"
                                    (keyup)="validateVolumeRange()" />
                            </div>
                            <span class="e-to-dash">-</span>
                            <div>
                                <input
                                    id="toVolume"
                                    class="e-number-input"
                                    type="text"
                                    [(ngModel)]="toVolume"
                                    [disabled]="!volumeChecked"
                                    (keyup)="validateVolumeRange()" />
                            </div>
                        </div>
                    </div>
                    <div class="e-sku-size-option-row">
                        <div>
                            <mat-checkbox [(ngModel)]="weightChecked" (click)="checkCancelAndFilterButton()">Weight</mat-checkbox>
                            <div>
                                <mat-form-field appearance="fill" class="e-mat-select-tiny">
                                    <mat-select
                                        panelClass="e-mat-select-panel-tiny"
                                        [disabled]="!weightChecked"
                                        [(value)]="weightSelected"
                                        (selectionChange)="onWeightSelectionChange($event)"
                                        [formControl]="frmControlWeight">
                                        <mat-option *ngFor="let unit of weightOptions" [value]="unit">
                                            {{ unit }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <button
                                    class="e-reset-button"
                                    aria-label="Reset weight selections to default values"
                                    [disabled]="!weightChecked">
                                    <i class="fa-regular fa-arrow-rotate-left" (click)="onWeightReset()"></i>
                                </button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <input
                                    id="fromWeight"
                                    class="e-number-input"
                                    type="text"
                                    [(ngModel)]="fromWeight"
                                    [disabled]="!weightChecked"
                                    (keyup)="validateWeightRange()" />
                            </div>
                            <span class="e-to-dash">-</span>
                            <div>
                                <input
                                    id="toWeight"
                                    class="e-number-input"
                                    type="text"
                                    [(ngModel)]="toWeight"
                                    [disabled]="!weightChecked"
                                    (keyup)="validateWeightRange()" />
                            </div>
                        </div>
                    </div>
                    <div class="e-sku-size-option-row">
                        <div>
                            <mat-checkbox [(ngModel)]="countChecked" (click)="checkCancelAndFilterButton()">Count</mat-checkbox>
                            <button class="e-reset-button" aria-label="Reset count selections to default values" [disabled]="!countChecked">
                                <i class="fa-regular fa-arrow-rotate-left" (click)="onCountReset()"></i>
                            </button>
                        </div>
                        <div>
                            <div>
                                <input
                                    id="fromCount"
                                    class="e-number-input"
                                    type="text"
                                    [(ngModel)]="fromCount"
                                    [disabled]="!countChecked"
                                    (keyup)="validateCountRange()" />
                            </div>
                            <span class="e-to-dash">-</span>
                            <div>
                                <input
                                    id="toCount"
                                    class="e-number-input"
                                    type="text"
                                    [(ngModel)]="toCount"
                                    [disabled]="!countChecked"
                                    (keyup)="validateCountRange()" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
